import { Notice } from '../models/notice';
import { NoticeTypeEnum } from '../enum/notice-type.enum';
import { NoticeLevelEnum } from '../enum/notice-level.enum';

export const noServiceNotice: Notice = {
    id: 'default_no_service',
    type: NoticeTypeEnum.NO_SERVICES_AVAILABLE,
    text: $localize`No services are currently available to you.`,
    level: NoticeLevelEnum.INFO,
    date: '',
    title: $localize`No Service Available`,
    preview: $localize`No services are currently available to you.`
};
